export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Computer</title>
    <path stroke="currentColor" strokeWidth="1.5" d="M3 7h26v15H3zM13 22h6l1 5h-8l1-5ZM9 27h14" />
  </svg>
);
